import { BrowserEvents, loadingBar } from '../global/constants';

;(function($) {

	$(document).on(BrowserEvents.barba.enter, function() {

		// ---------- Newsletter ----------

		if(typeof newsletter_params !== 'undefined') {

			$('form.newsletter-form').each(function() {

				const newsletterForm = $(this);

				const newsletterInput = newsletterForm.find('input[type=email]');
				const newsletterButton = newsletterForm.find('button[type=submit]');
				const newsletterTooltip = newsletterForm.find('.invalid-tooltip');
				const newsletterModal = $('#newsletter-form-modal');

				newsletterForm.on('submit', function(e) {
					e.preventDefault();
					e.stopImmediatePropagation();
					e.stopPropagation();

					newsletterInput.removeClass('is-invalid');
					newsletterButton.attr('disabled', true);
					loadingBar.classList.add('active');

					const formData = new FormData(newsletterForm[0]);
					console.log(newsletterInput.val());
					formData.append('action', newsletter_params.action);
					formData.append('nonce', newsletter_params.nonce);

					$.ajax({
						url: newsletter_params.url,
						type: 'POST',
						dataType: 'json',
						data: formData,
						processData: false,
						contentType: false,
					}).always(function(response) {

						newsletterButton.attr('disabled', false);
						loadingBar.classList.remove('active');

						if(response.success === true) {
							newsletterModal.modal('show');
							newsletterModal.find('input[name="email"]').val(newsletterInput.val());
							newsletterForm.empty();
							newsletterForm.append('<div class="success-message"><span>' + response.data.message + '</span></div>')
						}
						else {
							newsletterTooltip.text(response.data.error);
							newsletterInput.addClass('is-invalid');
							console.error(response);
						}
					});

					return false;
				});
			});

			$('form#newsletter-form-step-2').each(function() {

				const newsletterFormStep2 = $(this);

				newsletterFormStep2.on('submit', function(e) {
					e.preventDefault();
					e.stopImmediatePropagation();
					e.stopPropagation();

					const newsletterInput = newsletterFormStep2.find('input[name=email]');
					const newsletterButton = newsletterFormStep2.find('button[type=submit]');
					const newsletterTooltip = newsletterFormStep2.find('.invalid-tooltip');

					const formData = new FormData(newsletterFormStep2[0]);
					console.log(newsletterInput.val());
					formData.append('action', newsletter_params.action);
					formData.append('nonce', newsletter_params.nonce);

					$.ajax({
						url: newsletter_params.url,
						type: 'POST',
						dataType: 'json',
						data: formData,
						processData: false,
						contentType: false,
					}).always(function(response) {

						newsletterButton.attr('disabled', false);
						loadingBar.classList.remove('active');

						if(response.success === true) {
							newsletterFormStep2.empty();
							newsletterFormStep2.append('<div class="success-message"><span>' + response.data.message + '</span><br><br></div>')
						}
						else {
							newsletterTooltip.text(response.data.error);
							newsletterButton.addClass('is-invalid');
							console.error(response);
						}
					});

					return false;
				});
			});
		}
	});

}(jQuery));
